export { default, getStaticProps } from "app/seo/modes-de-paiement/page";
